import { Box } from 'braid-design-system';

export const ScreenReaderSkipTarget = ({ name }: { name: string }) => (
  <Box tabIndex={-1} id={name} />
);
